export default "__VITE_ASSET__D4vtCd2r__"